module.exports = __webpack_public_path__ + "img/image4.9db7f18c.jpg";